import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, removeToken } from '@/utils/auth'
import {getPageTitle} from '@/setting/index'
import store from './store'
import {pageSettingRoutes} from '@/router/index';

NProgress.configure({ showSpinner: false })
const whiteList = ['/login', '/auth-redirect', '/sso', '/three-redirect-url', '/login-error']

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  document.title = getPageTitle(to.meta.title)
  /** 免密登录 */
  if (to.path === '/sso') {
    removeToken();
    next()
    NProgress.done()
    return null
  }
  if (to.path === '/sso' || to.path === '/three-redirect-url' || to.path === '/login-error') {
      next()
      NProgress.done()
      return null
  }
  const hasToken = getToken()
  /** 未登录 */
  if (!hasToken) {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
    return null
  }
  /** 已登录访问login转跳/ */
  if (to.path === '/login') {
    validIsSettingMenu('close');
    next({ path: '/' })
    NProgress.done()
    return null
  }
  /** 已登录权限过滤 */
  if (to.path === '/404' || to.path === '/401') {
    next()
    NProgress.done()
    return null
  }
  /** 已登录权限判断 */
  const permission = to.meta.permission || '*'
  const isRole = await store.dispatch('user/hasPermission', permission);
  if (isRole) {
    validIsSettingMenu(false, to.path);
    next();
  } else {
    next(`/401`)
  }
  NProgress.done()
})
router.afterEach(() => {
  NProgress.done()
})

// 校验菜单状态
function validIsSettingMenu (status, toPath) {
  if (status === 'close') {
    store.commit('SETSETTINGMENU', status);
  } else {
    const isExits = pageSettingRoutes.findIndex(v => {
      return v.children.find(d => (`${v.path}/${d.path}` === toPath)) ?? -1 >= 0;
    }) ?? -1;
    store.commit('SETSETTINGMENU', isExits >= 0);
  }
}
